import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosHttp } from '../../AxiosWrapper';
import SignInModalView from './SignInModalView';
import { localdb, TOKEN_HEADER_KEY } from '../../utils/CommonUtil';

const AuthenticationContext = createContext({});
const excluded_redirected_path = ["/dss"]

const AuthenticationProvider = ({ children }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const openLoginModal = () => setShowLoginModal(true);
    const closeLoginModal = () => setShowLoginModal(false);


    useEffect(() => {
        handleResponseErrors(openLoginModal, navigate);
    }, []);


    const login = () => {
        openLoginModal();
    }


    const logedInSuccess = (data, redirect = true) => {
        if (showLoginModal) {
            closeLoginModal();
        }
        //adding loggedIn time
        data.user.loggedOn = Date.now();
        localdb.put("userData", JSON.stringify(data));
        const currentPath = window.location.pathname;
        if (currentPath == "/") {
            window.location.reload();
        } else {
            navigate("/");
        }

    };

    const isLoggedIn = () => {
        let user = localdb.get("userData") && JSON.parse(localdb.get("userData")).user;
        if (!user || !user.loggedOn || !user.sessionExpiredIn) {
            return false;
        }
        return (Date.now() - user.loggedOn) < parseInt(user.sessionExpiredIn);
    }

    const getUser = () => {
        if (localdb.get("userData")) {
            return JSON.parse(localdb.get("userData")).user;
        }
    }

    const logout = () => {
        clearUser();
        const currentPath = window.location.pathname;
        if (currentPath == "/") {
            window.location.reload();
        } else {
            navigate("/");
        }
    };

    const clearUser = () => {
        localdb.remove("userData");
    }

    const [userData, setUserData] = useState(getUser());

    const memoObj = useMemo(() => ({ login, logedInSuccess, logout, isLoggedIn, getUser, userData, closeLoginModal }),
        [userData, isLoggedIn]);
    return (
        <AuthenticationContext.Provider value={memoObj}>
            {children}
            {showLoginModal && <SignInModalView open={showLoginModal} close={closeLoginModal} />}
        </AuthenticationContext.Provider>
    )
}
AuthenticationProvider.propTypes = {
    children: PropTypes.string.isRequired,
};

const useAuthentication = () => {
    return useContext(AuthenticationContext);
}

export { AuthenticationProvider, useAuthentication };

const setRedirectPath = (redirectPath) => {
    let pathArr = excluded_redirected_path.filter(path => redirectPath.startsWith(path));
    if (!pathArr || pathArr.length === 0) {
        localdb.put("redirectPath", redirectPath);
    }

}

const getRedirectPath = (path) => {
    return localdb.get("redirectPath");
}

const handleResponseErrors = (openLoginModal, navigate) => {
    const responseInterceptor = axiosHttp.interceptors.response.use(response => {
        return response

    }, (error) => {
        if (error.status === 401) {//authentication
            openLoginModal();
        } else if (error.status === 403) {//Forbidden force logout
            navigate("/error/inactive");
        } else if (error.status === 404) {//No Found
        } else if ("ERR_NETWORK" === error.code) {
        } else if (error.response && error.response.status === 503) {//Service unavailable
            //underMaintenanceModal();
        } else {
            // toggleError(true, error);// all other internal errors
            //errorModal();
        }
        return Promise.reject(error)
    })

    return () => {
        axiosHttp.interceptors.response.eject(responseInterceptor);
    }
}

